'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimpleModel = undefined;
exports.default = createSimpleModel;

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = require('./utils');

var _serverErrors = require('./serverErrors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Model, that can be contained by another complex hateoasModel,
 * or declare request / response models
 */
var SimpleModel = exports.SimpleModel = Nested.Model.extend({
    initialize: function initialize() {
        this.postInitialize();
    },
    parse: function parse(response) {
        var model = response;
        var links = model._links;
        delete model._links;

        _underscore2.default.map(_underscore2.default.keys(links), function (linkName) {
            model[linkName] = (0, _utils.extractIdFromHateoasHref)(links[linkName].href);
        });

        return model;
    },


    /**
     * integration with nestedTypes
     */
    getStore: function getStore() {
        return this.declaredDomain.getCache().getCacheStore();
    },
    postInitialize: function postInitialize() {
        (0, _serverErrors.addServerErrorsIntegration)(this);
    },
    toJSON: function toJSON() {
        return (0, _utils.convertModel2Json)(this);
    },
    save: function save() {
        throw new Error('this model isn\'t resource');
    }
});

/**
 * create new simpleModel with app-specific props
 */
function createSimpleModel(className, domain) {
    var protoProps = { className: className, declaredDomain: domain };
    var staticProps = { className: className, declaredDomain: domain };

    return SimpleModel.extend(protoProps, staticProps);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/simpleModelFactory.js
// module id = 1426
// module chunks = 118